import { useState, useEffect, useCallback } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { ArrowRightCircle } from "react-bootstrap-icons";
import headerImg from "../assets/img/header-img.svg";
import "animate.css";
import TrackVisibility from "react-on-screen";
import dp from "../assets/img/DP1.png";

const TO_ROTATE = [
  "R&D Engineer",
  "Software Developer",
  "Systems & Telecom Engineer",
  "Full-Stack Developer",
];

export const Banner = () => {
  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [text, setText] = useState("");

  const tick = useCallback(() => {
    const i = loopNum % TO_ROTATE.length;
    const fullText = TO_ROTATE[i];

    const updateText = isDeleting
      ? fullText.substring(0, text.length - 1)
      : fullText.substring(0, text.length + 1);

    setText(updateText);

    if (!isDeleting && updateText === fullText) {
      setIsDeleting(true);
    } else if (isDeleting && updateText === "") {
      setIsDeleting(false);
      setLoopNum((prev) => prev + 1);
    }
  }, [loopNum, isDeleting, text]);

  useEffect(() => {
    const ticker = setInterval(
      tick,
      isDeleting ? 80 : 150
    );

    return () => clearInterval(ticker);
  }, [tick, isDeleting]);

  const scrollToSelector = (selector) => {
    const element = document.querySelector(selector);

    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="banner" id="home">
      <Container>
        <Row className="align-items-center">
          <Col xs={12} md={6} xl={7}>
            <img
              className="dp"
              src={dp}
              alt="Harsh Agria"
            />

            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible
                      ? "animate__animated animate__fadeIn"
                      : ""
                  }
                >
                  <span className="tagline">
                    Welcome to My Portfolio
                  </span>

                  <h1>
                    Hi, I'm Harsh Agria
                    <br />

                    <span
                      className="txt-rotate"
                      dataPeriod="1000"
                    >
                      <span className="wrap">{text}</span>
                    </span>
                  </h1>

                  <p>
                    R&D Engineer at HCLTech working on HPE's enterprise
                    telecom platform, building production-grade features
                    and solutions for large-scale systems serving users
                    across 10+ countries.
                    <br />
                    <br />
                    I graduated from NIT Kurukshetra with a B.Tech'25 in
                    Information Technology and work across C++, networking,
                    security, full-stack development, and RAG-based AI
                    systems.
                  </p>

                  <button
                    onClick={() => scrollToSelector("#connect")}
                  >
                    Let's Connect{" "}
                    <ArrowRightCircle size={25} />
                  </button>
                </div>
              )}
            </TrackVisibility>
          </Col>

          <Col xs={12} md={6} xl={5}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible
                      ? "animate__animated animate__zoomIn"
                      : ""
                  }
                >
                  <img
                    src={headerImg}
                    alt="Software development illustration"
                    className="headeranimimg"
                  />
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
